/// <reference path="appbase.ts" />

namespace TerminalApp {
    export class App_Slave extends AppBase {
        master: string;
        bound = false;
        output = document.getElementById("as_output");
        history: HTMLElement[] = [];
        constructor() {
            super("app_slave");
        }

        async scan(barcode: string) {

            //bypass
            if (barcode.startsWith("ps_") || barcode.startsWith("a_") || barcode.startsWith("te_")) {
                await this.close();
                await SP.setAllHash({ "app": "homescreen" });
                await SP.sleep(100);
                await barcodeListener.performScan(barcode);
                return;
            }

            console.log("Result PRE");

            var success = await hub.connection.invoke("ScanBarcode", parseInt(this.master), barcode);
            console.log("Result", success);
            var out = document.createElement("div");
            if (!success) out.classList.add("failed");
            out.innerText = barcode;

            this.history.push(out);
            this.output.prepend(out);

            if (this.history.length >= 10) {
                this.history[0].remove();
                this.history.splice(0, 1);
                
            }
        }

        setMaster(deviceId: string) {
            this.master = deviceId;
            document.getElementById("app_slave_master").innerHTML = deviceId;
        }

        async onOpen() {
            if (!this.bound) {
                barcodeListener.slaveMode = true;
                barcodeListener.on(null, this.scan, this);
                this.bound = true;
            }

            var parent = SP.getHash("parent");
            this.setMaster(parent);
        }

        async onClose() {
            if (this.bound) {
                barcodeListener.slaveMode = false;
                barcodeListener.off(null, this.scan);
                this.bound = false;
            }
        }
    }



    RegisterApp("app_slave", App_Slave);
}